import { createI18n } from "vue-i18n";

// При изменении языка переключаем файл /locals/_language_.json
function loadLocaleMessages() {
    const locales = import.meta.glob('./locales/*.json', { eager: true });
    const messages = {};
    Object.keys(locales).forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            const module = locales[key];
            messages[locale] = module.default || module;
        }
    });
    return messages;
}

// Определяем предустановленный язык браузера и устанавливаем его при запуске
function detectLanguage() {
    const lng = window.navigator.userLanguage || window.navigator.language;
    const locales = import.meta.glob('./locales/*.json', { eager: true });
    const localeKeys = Object.keys(locales);
    const lang = localeKeys.find((key) => {
        const localeName = key.replace('./locales/', '').replace('.json', '');
        return lng.includes(localeName);
    });
    return lang ? lang.replace('./locales/', '').replace('.json', '') : null;
}

export default createI18n({
    legacy: true,
    globalInjection: true,
    // В сообщениях активно используется HTML (br, sup и т.п.),
    // поэтому отключаем предупреждения vue-i18n об HTML в строках.
    // Доверяем содержимому, так как оно хранится в локальных JSON‑файлах.
    warnHtmlInMessage: 'off',
    locale:
        localStorage.getItem("lang") ||
        detectLanguage() ||
        import.meta.env.VITE_I18N_LOCALE ||
        "ru",
    fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || "ru",
    messages: loadLocaleMessages(),
});
